module.exports = __webpack_public_path__ + "media/images/athletes/1543-75cca29573bf938dd7ab1308f81e24a6.png";